import type { Model } from "@/types";
import type { IDefaultModel } from "@/types/conversations";

type ResolveModelSelectionOptions = {
  models: Model[];
  defaults: IDefaultModel[];
  selectedModelId: string;
  selectedPlannerModelId: string;
};

export const resolveModelSelection = ({
  models,
  defaults,
  selectedModelId,
  selectedPlannerModelId,
}: ResolveModelSelectionOptions) => {
  const fallbackModel = models[0];
  const getDefaultModel = (mode: "base" | "planner") => {
    const defaultModelId = defaults.find(
      (model) => model.mode === mode,
    )?.llm_config.id;

    return models.find((model) => model.id === defaultModelId) || fallbackModel;
  };

  return {
    modelId: models.some((model) => model.id === selectedModelId)
      ? selectedModelId
      : getDefaultModel("base")?.id,
    plannerModelId: models.some(
      (model) => model.id === selectedPlannerModelId,
    )
      ? selectedPlannerModelId
      : getDefaultModel("planner")?.id,
  };
};
